import {GuidingTourDTO} from 'hemwb-api';
import {AsyncAction} from '../asyncUtilsTypes';

export enum GuidingTourActions {
  FETCH_DETAIL = 'GUIDINGTOUR/FETCH_DETAIL',
}

export type GuidingTourAction = AsyncAction<GuidingTourActions.FETCH_DETAIL, GuidingTourDTO, [string, string]>;
